module.exports = __webpack_public_path__ + "static/media/key.7b934970.svg";